import Swiper, { Autoplay, Pagination } from "swiper";

export const createBettoBannerSwiper = ({
	container,
	pagination,
	slideCount,
	autoplayDelay = 5000,
}) => {
	const canSlide = slideCount > 1;

	return new Swiper(container, {
		modules: [Autoplay, Pagination],
		speed: 500,
		slidesPerView: 1,
		slidesPerGroup: 1,
		loop: false,
		rewind: canSlide,
		observer: true,
		observeParents: true,
		watchSlidesProgress: true,
		updateOnWindowResize: true,
		autoplay: canSlide
			? {
					delay: autoplayDelay,
					disableOnInteraction: false,
					pauseOnMouseEnter: true,
				}
			: false,
		pagination: {
			el: pagination,
			type: "bullets",
			clickable: true,
		},
	});
};
